const dateFormats = {
	dateTime: 'DD MMM YYYY, HH:mm',
	date: 'DD MMM YYYY',
};

export default dateFormats;
